import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable, Req } from '@nestjs/common';
import { ColumnsRepository } from './columns.repository';
import { Columns } from './colunms.entity';
import { ColumnsRequest } from './dto/column-request';
import { ColumnsAdapter } from './dto/columns-adapter';
import { ColumnsDTO } from './dto/columns.dto';
import { ColumnsDtoActive } from './dto/columns_active_inactive';
import {CreateColumnsResponseModel,AllColumnsResponseModel,ColumnsResponseModel,ColumnResponse,ColumnDto, ColumnsDropDownResponseModel, ColumnDropDownDto} from '@gtpl/shared-models/masters'
import { ZoneRackLevelByIdDto } from './dto/zoneId-request-dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';



@Injectable()
export class ColumnsService {
    constructor(
      private logService:LogsService,

        private repository: ColumnsRepository, private adapter: ColumnsAdapter) {

    }


    async CreateColumns(details: ColumnsDTO, isUpdate: boolean): Promise<CreateColumnsResponseModel> {
        try {
        if (!isUpdate) {
            const columnEntity = await this.getcolumn(details.columnsCode, details.columnsNo);
            if (columnEntity) {
                throw new CreateColumnsResponseModel(false,11104, 'Column  already exists');
            }
        }else{
            const columnEntity = await this.getcolumnForUpdate(details.columnsCode, details.columnsNo,details.columnsId);
            console.log(columnEntity);
            if(columnEntity){
                if(columnEntity.columnsId!= details.columnsId) {
                    throw new CreateColumnsResponseModel(false,11104, 'Column already exists');      
                }
            }
        }
        const convertedEntity = await this.adapter.convertDtoToEntity(details);
        const response = await this.repository.save(convertedEntity);
        if (response) {
            const data = new ColumnDto(response.columnsCode, response.columnsNo, response.createdUser, response.isActive, response.updatedUser);
            const respons = new CreateColumnsResponseModel(true, 2234, 'Column Details Created Successfully', data)
            const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'Columns', response.columnsId, true, '',response.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return respons
        } else {
            throw new CreateColumnsResponseModel(false,9999, 'Failed To Create');
        }
    }catch (error) {
        return error;
      }
    }

    async getAllColumns(): Promise<AllColumnsResponseModel> {
        const responseDate = await this.repository.find({order:{columnsNo:"ASC"}});

        const columnDetails: ColumnDto[] = [];
        if (responseDate.length > 0) {
            responseDate.forEach((column) => {
                const columnData = new ColumnDto(column.columnsCode, column.columnsNo, column.createdUser, column.isActive, column.updatedUser, column.columnsId, column.versionFlag);
                columnDetails.push(columnData);
            })
            const resp =  new AllColumnsResponseModel(true, 2234, 'column Details Retrived Successfully', columnDetails)
            const newLogDto = new LogsDto(1,'view', 'Columns', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return resp
        } else {
            throw new CreateColumnsResponseModel(false,9999, 'No Data Found');
        }
    }


    async getRecordByColumnsId(id: number): Promise<ColumnsResponseModel> {
        const responseData = await this.repository.findOne({ where: { columnsId: id } });

        if (responseData) {
            const data = new ColumnDto(responseData.columnsCode, responseData.columnsNo, responseData.createdUser, responseData.isActive, responseData.updatedUser);
            return new ColumnsResponseModel(true, 7879, 'Data Retrived Successfully', data);
        } else {
            throw new CreateColumnsResponseModel(false,9999, 'No Data Found');
        }
    }

    async getcolumn(columnsCode: String, columnsNo: number): Promise<Columns> {
        const response = await this.repository.findOne({
            where: { columnsCode: columnsCode, columnsNo: columnsNo },
        });

        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getcolumnForUpdate(columnsCode: String, columnsNo:number, id: number ): Promise<Columns> {
        const responseCode = await this.repository.findOne({
            where: { columnsCode: columnsCode },
        });
        const responseNo = await this.repository.findOne({
            where: {columnsNo: columnsNo },
        });
        if (responseCode || responseNo) {
            if(responseCode && responseNo){
                if(responseCode.columnsId == responseNo.columnsId){
                    return responseCode;
                }
                else if( responseCode.columnsId == id){
                    return responseNo;
                }
                else if( responseNo.columnsId == id){
                    return responseCode;
                }
                else{
                    return responseCode;
                }
            }
            else if(responseCode && !responseNo){
                return responseCode;
            }
            else if(responseNo && !responseCode){
                return responseNo;
            }
        } else {
            return null;
        }
    }
    


    async getColumnsData(columnsId: number): Promise<Columns> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { columnsId: columnsId },
        });

        if (response) {
            return response;
        } else {
            return null;


        }
    }
    async getColumnsById(columnsRequest: ColumnsRequest): Promise<ColumnsResponseModel> {
        try {
            const columnsData = await this.repository.findOne({
                where: { columnsId: columnsRequest.columnsId },
            });
            const columnDto = new ColumnDto(columnsData.columnsCode, columnsData.columnsNo, columnsData.createdUser, columnsData.isActive, columnsData.updatedUser, columnsData.columnsId, columnsData.versionFlag)
            const response = new ColumnsResponseModel(true, 1101, "column retrived successfully", columnDto)
            return response;
        } catch (err) {
            throw err;
        }
    }
    async activateorDeactivateColumn(columnAct: ColumnsDtoActive): Promise<ColumnResponse> {
        try {
            const columnExists = await this.getColumnsData(columnAct.columnsId);
            if (columnExists) {
                if (columnAct.versionFlag !== columnExists.versionFlag) {
                    throw new CreateColumnsResponseModel(false,10113, 'Someone updated the current columns information.Refresh and try again');
                } else {

                    const columnSatatus = await this.repository.update(
                        { columnsId: columnAct.columnsId },
                        { isActive: columnAct.isActive, updatedUser: columnAct.updatedUser });
                    const updatedRecord = await this.getRecordByColumnsId(columnAct.columnsId);
                    if (columnExists.isActive) {
                        if (columnSatatus.affected) {
                            const columnResponse: ColumnResponse = new ColumnResponse(true, 10115, 'Columns is de-activated successfully');
                            return columnResponse;
                        } else {
                            throw new CreateColumnsResponseModel(false,10111, 'Column is already deactivated');
                        }
                    } else {
                        if (columnSatatus.affected) {
                            const columncatResponse: ColumnResponse = new ColumnResponse(true, 10114, 'Column is activated successfully', updatedRecord.data);
                            return columncatResponse;
                        } else {
                            throw new CreateColumnsResponseModel(false,10112, 'column is already  activated');
                        }
                    }
                }
            } else {
                throw new CreateColumnsResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getColumnById(columnsId: number): Promise<Columns> {
        const Response = await this.repository.findOne({
        where: {columnsId: columnsId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }

    async getAllColumnDropDown(): Promise<ColumnsDropDownResponseModel> {
      try {
          const columnsDTO: ColumnDropDownDto[] = [];
          const columnsEntities: Columns[] = await this.repository.find({ select: ['columnsId', 'columnsNo','columnsCode'], where: { isActive: true }})


          if (columnsEntities && columnsEntities.length > 0) {
              columnsEntities.forEach(columnsEntity => {
                  columnsDTO.push(new ColumnDropDownDto(columnsEntity.columnsId, columnsEntity.columnsNo,columnsEntity.columnsCode));
              });
              const response = new ColumnsDropDownResponseModel(true, 11108, "columns retrieved successfully", columnsDTO);
              return response;
          } else {
              throw new CreateColumnsResponseModel(false,99998, 'Data not found');
          }
      } catch (err) {
          throw err;
      }
  }

 
  async getColumnsForZoneLevelRackId(zoneRackLevelIdReq:ZoneRackLevelByIdDto): Promise<ColumnsDropDownResponseModel> {
      try {
          const column: ColumnDropDownDto[] = [];
          const columnsEntities: Columns[] = await this.repository.find({ select: ['columnsId', 'columnsNo','columnsCode'], where: { isActive: true}})


          if (columnsEntities && columnsEntities.length > 0) {
              columnsEntities.forEach(columnsEntities => {
                  column.push(new ColumnDropDownDto(columnsEntities.columnsId, columnsEntities.columnsNo,columnsEntities.columnsCode));
              });
              const response = new ColumnsDropDownResponseModel(true, 11108, "columns retrieved successfully",column);
              return response;
          } else {
              throw new CreateColumnsResponseModel(false,99998, 'Data not found');
          }
      } catch (err) {
          throw err;
      }
  }





}
